var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Estrella",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.02,
    height: 17.119,
    viewBox: "0 0 18.02 17.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-star",
    "data-name": "Icon material-star",
    d: "M12.01,16.758l5.568,3.361L16.1,13.785,21.02,9.523l-6.478-.55L12.01,3,9.478,8.974,3,9.523l4.919,4.262L6.442,20.119Z",
    transform: "translate(-3 -3)",
    fill: "#b3cc1d",
    opacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-star-half",
    "data-name": "Icon material-star-half",
    d: "M21.02,9.523l-6.478-.559L12.01,3,9.478,8.974,3,9.523l4.919,4.262L6.442,20.119l5.568-3.361,5.568,3.361L16.11,13.785Zm-9.01,5.55V6.694l1.541,3.64,3.946.342-2.991,2.595.9,3.856Z",
    transform: "translate(-3 -3)",
    fill: "#b3cc1d",
    opacity: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-star-border",
    "data-name": "Icon material-star-border",
    d: "M21.02,9.523l-6.478-.559L12.01,3,9.478,8.974,3,9.523l4.919,4.262L6.442,20.119l5.568-3.361,5.568,3.361L16.11,13.785Zm-9.01,5.55L8.622,17.119l.9-3.856L6.532,10.668l3.946-.342L12.01,6.694l1.541,3.64,3.946.342-2.991,2.595.9,3.856Z",
    transform: "translate(-3 -3)",
    fill: "#b3cc1d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.d5e3181ef50189e24c6575361ad463e0.svg";
export { ForwardRef as ReactComponent };